/* 유저 정보 */
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_ADMIN = "GET_USER_ADMIN";

/* 가족 정보 */
export const GET_FAMILY_INFO = "GET_FAMILY_INFO";

/* 운동 횟수 정보 */
export const GET_WORKOUT_COUNT = "GET_WORKOUT_COUNT";

/* 파일 업로드 */
export const GET_FILE_UPLOAD = "GET_FILE_UPLOAD";

/* 식단 */
export const GET_DIET = "GET_DIET";

/* 복약 */
export const GET_PILL = "GET_PILL";

/* 복용 기록 */
export const GET_PILL_HISTORY = "GET_PILL_HISTORY";

/* 포인트 기록 */
export const GET_POINT = "GET_POINT";

/* 보유 포인트 */
export const GET_TOTAL_POINT = "GET_TOTAL_POINT";

/* 걷기 */
export const GET_WALK = "GET_WALK";

/* 걷기 */
export const GET_NOTIFICATION = "GET_NOTIFICATION";
